import { configureStore } from '@reduxjs/toolkit';

import { environment } from '@paragon/environment-tools';
import { logInData } from '@paragon/login-tools';
import { spinnerMessages } from '@paragon/task-spinner';
import { theme } from '@paragon/themes';

import { loadingFiles } from './loadingFilesSlice';
import { packing } from './packingSlice';

export const store = configureStore({
  reducer: {
    logInData,
    spinnerMessages,
    environment,
    theme,
    packing,
    loadingFiles,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
